import { Component, OnInit, ChangeDetectionStrategy, Input } from "@angular/core";
import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { Information } from "../definition";
import { GetInformations } from "../stores/app.action";
import { AppState } from "../stores/app.state";

@Component({
    selector: "app-dashboard-informations",
    template: `
        <div class="px-normal mt-3">
            <h2 class="text-primary-500 font-bold mb-3">{{ "Die Blauen Ratgeber der deutschen Krebshilfe" | translate }}</h2>

            <ng-container *ngIf="informations.length; else empty">
                <div class="flex ">
                    <div class="w-1/3 mr-normal">
                        <img [src]="informations[0]?.image" *ngIf="informations[0]?.image" />
                    </div>
                    <div class="w-2/3">
                        <h2 class="text-base font-bold mb-1">
                            {{ "Dieser Blaue Ratgeber ist Teil einer Broschürenserie, die sich an Krebsbetroffene, Angehörige und Interessierte richtet." | translate }}
                        </h2>
                        <ul class="list-disc list-outside ml-3 space-y-2">
                            <li>{{ "Die Blauen Ratgeber geben ANTWORTEN auf medizinisch drängende Fragen." | translate }}</li>
                            <li>{{ "Sie bieten konkrete HILFEN an, um die Erkrankung zu bewältige." | translate }}</li>
                            <li>{{ "und zeigen PERSPEKTIVEN auf für ein Leben mit und nach Krebs." | translate }}</li>
                        </ul>
                    </div>
                </div>
                <div class="mt-3">
                    <h2 class="text-primary-500 font-bold mb-3">{{ "Blaue Ratgeber" | translate }}</h2>
                    <ion-list *ngIf="showList">
                        <ion-item *ngFor="let item of informations" [href]="item.url" target="_blank">
                            <ion-label>
                                <h2>{{ item.title }}</h2>
                            </ion-label>
                            <ion-button fill="clear" slot="end">
                                <fa-icon slot="icon-only" [icon]="['fal', 'link']" size="lg" [fixedWidth]="true"></fa-icon>
                            </ion-button>
                        </ion-item>
                    </ion-list>
                </div>

                <div *ngIf="!showList">
                    <div class="px-normal flex justify-center mt-3" *ngIf="informations.length == 1">
                        <ion-button (click)="open(informations[0])" fill="outline" shape="round">
                            {{ "Blauen Ratgeber öffnen" | translate }}
                        </ion-button>
                    </div>
                    <div class="px-normal flex justify-center mt-3" *ngIf="informations.length > 1">
                        <ion-button [routerLink]="['/informations']" [queryParams]="{ view: 'info' }" fill="outline" shape="round">
                            {{ "Blaue Ratgeber öffnen" | translate }}
                        </ion-button>
                    </div>
                </div>
            </ng-container>

            <ng-template #empty>
                <app-view-empty [lead]="'Wir konnten leider keine passenden blauen Ratgeber finden' | translate" [icon]="['fal', 'info-circle']"> </app-view-empty>
            </ng-template>
        </div>
    `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardInformationsComponent implements OnInit {
    @Input() informations = [];
    @Input() showList = false;

    constructor() {}

    ngOnInit(): void {}
    open(information: Information) {
        window.open(information.url, "_blank");
    }
}
